import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Dynamically load and initialize Bugsnag, then render the app
import("./bugsnag-setup").then(async ({ default: setupBugsnag }) => {
  const { ErrorBoundary } = await setupBugsnag();
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<ErrorBoundary><App /></ErrorBoundary>);
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
    .then(async () => {
      console.log("Beams Service worker registered");
    })
    .catch(err => console.error("Service worker failed", err));
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

